<template>
    <b-container>
        <b-card v-if="stakeId===null">
            <router-link  :to="{name: 'stake-list'}" active> Back to Stake List </router-link>
            <h4>Create a new Stake.{{stakeId}}</h4>        
        </b-card>        
        <b-card v-if="stakeId!==null">
            <router-link :to="{name: 'stake-detail', params: { 'stakeId': stakeId}}" active> Back to Stake List </router-link>
            <h1>Stake Name: {{stake.stake_name}}</h1>
        </b-card>
        <b-card>
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-1"
                    label="Stake Name:"
                    label-for="input-1"
                    description="Name of Stake.">
                    <b-form-input
                        id="input-1"
                        v-model="stake.stake_name"
                        type="text"
                        placeholder="Enter Stake Name"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-2"
                    label="Stake City:"
                    label-for="input-2"
                    description="City where Stake is located">
                    <b-form-input
                        id="input-2"
                        v-model="stake.stake_city"
                        type="text"
                        placeholder="Enter Stake City"
                        required>
                    </b-form-input>
                </b-form-group>     
                <b-button type="submit" variant="primary"> {{buttonText}}</b-button>
            </b-form>
        </b-card>
    </b-container>
</template>
<script>
import { StakeApi } from "@/app/stakes/stakeApi";
import handleError from '@/errorHandler';
export default {
    name: "StakeInfo",
    props: {
        stakeId: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            stake: {
                stake_id: null,
                stake_name: null,
                stake_city: null,
            }
        };
    },
    computed:{
        buttonText(){
            if(this.stakeId !==null)
                return "Update"
            return "Create"
        }


        
    },
    async mounted () {
        //log(this.stakeId);
        if(this.stakeId!==null)
            this.stake = await this.getStake();
        //console.log(this.stakeId);

    },
    methods: {
        async getStake() {
            try{
                const { data } = await StakeApi.getStakeDetail(this.stakeId);
                //console.log(data);
                return data;
            }catch (e) {
                handleError(e, "Error fetching stake details");
            }
        },
        async onSubmit(event) {
            event.preventDefault();
            try{
                if(this.stakeId!==null) {
                    const { data } = await StakeApi.updateStakeDetail(this.stakeId, this.stake);
                    this.$toast.success("Successfully Updated Stake");
                    this.$router.push({ name: 'stake-detail',params: { stakeId: this.stakeId}});
                }else{
                    const { data } = await StakeApi.createStake(this.stake);
                    this.$toast.success("Successfully Created Stake");
                    this.$router.push({ name: 'stake-list',params: { stakeId: this.stakeId}});

                }
            } catch(e)
            {
                let msg="Could not update stake";
                if(this.stakeId===null)
                    msg="Could not create stake";
                handleError(e, msg);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>